import { SxProps, Theme } from '@mui/material';

export const layoutMainSX = (_firstSlotCount: number, tokenName?: string): SxProps<Theme> => ({
	maxWidth: '1440px',
	width: '100%',
	...(tokenName === 'CategoryToken' ? { gap: '0px' } : {}),
	'@media (min-width:1440px)': {
		padding: '10px 0',
		margin: '0 auto',
	},
	'@media (min-width:801px) and (max-width:1439px)': {
		padding: '20px',
	},
	'@media (max-width:800px)': {
		padding: '10px',
	},
});

export const widgetContainerSx: SxProps<Theme> = {
	width: '100%',
};

export const getAsideContainerSx = (
	breakpoint: number,
	isAccountPage: boolean
): SxProps<Theme> => ({
	'&&': {
		padding: 0,
		flex: '1 1 100%',
		[`@media (min-width:${breakpoint}px)`]: {
			flex: '0 0 auto',
			...(isAccountPage ? { maxWidth: '25%' } : { maxWidth: { xs: '25%', lg: '18%' } }),
		},
	},
});

export const getSectionContainerSx = (
	breakpoint: number,
	isAccountPage: boolean
): SxProps<Theme> => ({
	'&&': {
		...(isAccountPage ? {} : { maxWidth: '100%' }),
		minWidth: 0,
		padding: 0,
		paddingLeft: '0',
		paddingTop: '20px',
		flex: '1 1 100%',
		[`@media (min-width:${breakpoint}px)`]: {
			...(isAccountPage ? { maxWidth: '75%' } : { maxWidth: { xs: '75%', lg: '82%' } }),
			p: '20px',
			flex: '1 1 0%',
		},
	},
});

export const mainContainerSx: SxProps<Theme> = {
	mb: { xs: '20px', md: '35px' },
};

export const stickySidebarSx: SxProps<Theme> = {
	position: 'sticky',
	top: 0,
};
